import React from 'react';
import { st, classes } from './SidebarDividerNext.st.css';
import Divider from '../Divider';
import { SidebarNextContext } from '../SidebarNext/SidebarNextContext';
import { SKINS } from './SidebarDividerNext.constants';
import { WixDesignSystemContext } from '../WixDesignSystemProvider/context';
import { SidebarDividerNextProps } from './SidebarDividerNext.types';

/** A divider within the sidebar that supports inner and full mode */
class SidebarDividerNext extends React.PureComponent<SidebarDividerNextProps> {
  static displayName = 'SidebarDividerNext';
  render() {
    const { dataHook, fullWidth } = this.props;

    return (
      <WixDesignSystemContext.Consumer>
        {() => (
          <SidebarNextContext.Consumer>
            {context => {
              const skin = context?.skin || SKINS.dark;

              return (
                <div
                  data-hook={dataHook}
                  data-skin={skin}
                  data-full-width={fullWidth}
                  className={st(
                    classes.root,
                    fullWidth ? classes.fullWidth : '',
                  )}
                  aria-hidden="true"
                >
                  <Divider className={st(classes.divider, { skin })} />
                </div>
              );
            }}
          </SidebarNextContext.Consumer>
        )}
      </WixDesignSystemContext.Consumer>
    );
  }
}

export default SidebarDividerNext;
